export default __webpack_public_path__ + "static/media/benefits.2675b8fd.svg";